import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

interface props {
	element: any;
}

const ProtectedRoute: React.FC<props> = ({ element }) => {
	const [authenticated, setAuthenticated] = useState(false);
	const [loading, setLoading] = useState(true);

	const serverUrl = `${process.env.REACT_APP_PROTOCOL}://${process.env.REACT_APP_SERVER_HOST}:${process.env.REACT_APP_SERVER_HOST_PORT}`;

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(`${serverUrl}/api/protected`, {
					withCredentials: true,
				});
				const apiData = response.data;

				if (
					apiData.status === "success" &&
					apiData.msg === "user is authenticated"
				) {
					setAuthenticated(true);
				} else {
					setAuthenticated(false);
				}
			} catch (error) {
				console.error(error);
				setAuthenticated(false);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [serverUrl]);

	if (loading) {
		return <div>Loading...</div>;
	}

	return authenticated ? element : <Navigate to="/login" />;
};

export default ProtectedRoute;
